import { Fragment } from 'react'

/* blocks */
import MobileHeader from './MobileHeader'
import DesktopHeader from './DesktopHeader'

export interface HeaderProps {
  className?: string
  primaryCta?: { title: string; url: string } | null
  secondaryCta?: { title: string; url: string } | null
  mode?: 'dark' | 'light'
  leaderLinkList: {
    id: string
    title: string
    href: string
  }[]
}

function Header({
  primaryCta = {
    title: 'Explore Pepper',
    url: '/'
  },
  mode,
  leaderLinkList
}: HeaderProps) {
  return (
    <Fragment>
      <MobileHeader
        className="lg:hidden"
        primaryCta={primaryCta}
        leaderLinkList={leaderLinkList}
      />
      <DesktopHeader
        className="hidden lg:block"
        primaryCta={primaryCta}
        mode={mode ?? 'light'}
        leaderLinkList={leaderLinkList}
      />
    </Fragment>
  )
}

export default Header
